module.exports = __webpack_public_path__ + "img/illustration_home_laundry_basket.d5a6ba0e.svg";